import { styled } from "@mui/material/styles";
import { TextField, Select, Typography } from "@mui/material";

// A container for each form row
export const FieldContainer = styled("div")(() => ({
  marginBottom: "16px",
  display: "flex",
  flexDirection: "column",
}));

// The label on top
export const FieldLabel = styled("label")(() => ({
  font: "var(--body-sm)",
  color: "var(--neutral-1000)",
  marginBottom: "8px",
  textAlign: "left",
  width: "100%",
  fontFamily: "Lexend",
}));

// The "icon + input" wrapper
export const InputWrapper = styled("div")(() => ({
 
  display: "flex",
  alignItems: "left",
}));

// An absolute icon to the left
export const IconLeft = styled("div")(() => ({
  position: "absolute",
  left: "12px",
  color: "#999",
  display: "flex",
  alignItems: "center",
  pointerEvents: "none", // so it doesn't block clicks
  zIndex: 1,
}));

// A standard text input or text area with left padding for the icon
export const StyledTextField = styled(TextField)(() => ({
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          backgroundColor: "var(--neutral-50)",
          padding: "12px 14px",
          font: "var(--body-sm)",
          "& fieldset": {
            borderColor: "var(--neutral-200)",
          },
          "& placeholder": {
            color: "var(--neutral-400)",
          },
          "& .MuiInputBase-input": {
            padding: "0",
          },
        },
  // Adjust the label to shift left if you're using MUI label
}));

// For multi-line text (Bio), if you want a "minHeight" approach, you can apply custom styles
export const StyledTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    // paddingLeft: "42px",
    borderRadius: 8,
    backgroundColor: "var(--neutral-50)",
  },
}));

// For the category Select to also have an icon
export const StyledSelect = styled(Select)(() => ({
  width: "100%",
  height: "44px",
  borderRadius: "8px",
  borderWidth: "1px",
  padding: "12px 0 12px 12px", // Spacing/3x for top, bottom, left; Spacing/0 for right
  gap: "8px", // Spacing/2x
  backgroundColor: "var(--neutral-50)",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "var(--neutral-50)",
  },
  fontFamily: "Lexend",
}));

// For error messages
export const ErrorText = styled(Typography)(() => ({
  color: "red",
  fontSize: "12px",
  marginTop: "4px",
  textAlign: "left",
}));

